"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MEMBER_EXPORT_SYNC_ROW_CAP = exports.MemberExportQuerySchema = exports.MEMBER_EXPORT_FORMATS = exports.MemberExportSortSchema = exports.MemberExportPresetSchema = exports.MEMBER_EXPORT_PRESETS = exports.MemberExportFilterClauseSchema = exports.MEMBER_EXPORT_OPERATORS = void 0;
var zod_1 = require("zod");
/**
 * Member Export — shared contract between UI, preview, count and download.
 *
 * Field ids are the canonical identifiers exposed by the backend field registry
 * (`GET /admin/exports/members/fields`). The frontend only sends ids; never raw
 * Mongo paths. The backend resolves them against the registry, which is the
 * security boundary that prevents arbitrary field access.
 */
exports.MEMBER_EXPORT_OPERATORS = [
    'eq',
    'neq',
    'in',
    'startsWith',
    'contains',
    'gt',
    'gte',
    'lt',
    'lte',
    'between',
    'isSet',
    'isNotSet',
];
exports.MemberExportFilterClauseSchema = zod_1.z.object({
    fieldId: zod_1.z.string().min(1),
    operator: zod_1.z.enum(exports.MEMBER_EXPORT_OPERATORS),
    value: zod_1.z.unknown().optional(),
    valueTo: zod_1.z.unknown().optional(),
});
exports.MEMBER_EXPORT_PRESETS = [
    'allUnpaid',
    'allPaidUp',
    'allPaidCrew',
    'allPartners',
    'currentContacts',
    'external',
    'internal',
    'longStanding',
    'optedOutOfAutoRenewal',
];
exports.MemberExportPresetSchema = zod_1.z.enum(exports.MEMBER_EXPORT_PRESETS);
exports.MemberExportSortSchema = zod_1.z.object({
    fieldId: zod_1.z.string().min(1),
    dir: zod_1.z.enum(['asc', 'desc']),
});
exports.MEMBER_EXPORT_FORMATS = ['json', 'csv', 'xlsx'];
/**
 * The single typed contract.
 * - `filters` max 20: performance budget; more than that is a smell.
 * - `sort` max 2: every extra sort key implies another compound index.
 * - `pageSize` max 200: preview only; export ignores this.
 */
exports.MemberExportQuerySchema = zod_1.z.object({
    filters: zod_1.z.array(exports.MemberExportFilterClauseSchema).max(20).default([]),
    columns: zod_1.z.array(zod_1.z.string().min(1)).min(1).max(40),
    sort: zod_1.z.array(exports.MemberExportSortSchema).max(2).default([]),
    dateField: zod_1.z.string().optional(),
    dateFrom: zod_1.z.coerce.date().optional(),
    dateTo: zod_1.z.coerce.date().optional(),
    preset: exports.MemberExportPresetSchema.optional(),
    search: zod_1.z.string().trim().min(1).optional(),
    format: zod_1.z.enum(exports.MEMBER_EXPORT_FORMATS).default('json'),
    limit: zod_1.z.number().int().min(1).max(10000).optional(),
    page: zod_1.z.number().int().min(1).optional(),
    pageSize: zod_1.z.number().int().min(1).max(200).optional(),
});
/** Hard sync cap. Past this, callers must use the async path (Phase 3). */
exports.MEMBER_EXPORT_SYNC_ROW_CAP = 10000;
//# sourceMappingURL=MemberExport.js.map